import { ClienteDto } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import { AppStateManager } from "common/helpers/app-state-manager.utils";
import { BooleanValues } from "constants/global";
import {
	companyAddCompany,
	companyGetCompanyDetails,
	companySetCompany,
	companySetIdCliente,
	companySetIdCompany,
	companyUpdateCompany,
} from "./actions";

const { TRUE, FALSE } = BooleanValues;

export interface CompanyReducerType {
	idCompany: string | undefined;
	idCliente: string | undefined;
	companyDetails: ClienteDto | undefined;
}

const initialState: CompanyReducerType = {
	idCompany: AppStateManager.getIdCompany() || undefined,
	idCliente: AppStateManager.getIdCliente() || undefined,
	companyDetails: sessionStorage.getItem("companyDetails")
		? JSON.parse(sessionStorage.getItem("companyDetails") || "")
		: undefined,
};

export const companyReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(companySetIdCompany, (state, action) => {
			state.idCompany = action.payload;
			AppStateManager.setIdCompany(action.payload);
		})
		.addCase(companySetIdCliente, (state, action) => {
			state.idCliente = action.payload;
			AppStateManager.setIdCliente(action.payload);
		})
		.addCase(companySetCompany, (state, action) => {
			sessionStorage.setItem("companyDetails", JSON.stringify(action.payload));
			state.companyDetails = action.payload;
		})
		.addCase(companyAddCompany.fulfilled, (state, action) => {
			state.companyDetails = action.payload;
		})
		.addCase(companyGetCompanyDetails.fulfilled, (state, action) => {
			state.companyDetails = action.payload;
		})
		.addCase(companyUpdateCompany.fulfilled, (state, action) => {
			if (action.payload) {
				state.companyDetails = action.payload;
			}
		});
});
